import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Bert } from 'meteor/themeteorchef:bert';
import { isEqual, isEmpty, isNil, find, forEach, cloneDeep, delay } from 'lodash';
import { withTracker } from 'meteor/react-meteor-data';
import { Meteor } from 'meteor/meteor';
import { Alert } from 'react-bootstrap';

import {
  setWaypointTelemetryArray,
  setFinalWaypointList
} from '../../../api/Missions/mission-methods-client';
import * as missionOps from '../../../api/Missions/mission-operations';
import * as rpaOps from '../../../api/RPAs/rpa-operations';
import TelemetryConnections from '../../../api/TelemetryConnections/TelemetryConnections';

import WebSocketTelemetry from '../../../modules/flight-telemetry';
import handleErrorInClient from '../../../modules/handle-error-in-client';
import methodPromise from '../../../modules/method-promise-wrapper';
import {
  convertWaypointArrayToGeoJSON,
  setWaypointNumbers,
  convertWaypointFeatureCollection2TelemetryArray,
  getTakeOffElevation
} from '../../../modules/waypoint-utilities';

import Loading from '../../components/Loading';

class TelemetryContainer extends Component {
  state = {
    telemetryConnection: '',
    imuCal: false,
    imuMessage: 'Accel Calibration Messages',
    lastMessageTimeStamp: '',
    connectionWebsocket: false,
    connectionSerial: false,
    receivingData: false,
    attitudeData: {
      pitchRead: 0,
      rollRead: 0,
      yawRead: 0
    },
    ports: [],
    toPort: '',
    bauds: 57600,
    GPSData: {
      altRead: 0,
      lonRead: 0,
      latRead: 0,
      signalType: 'No GPS',
      speedRead: 0,
      courseOverGround: 0,
      numberOfSatellites: 0
    },
    VFRData: {
      airspeed: 0
    },
    HeartBeat: {
      mode: 'disarmed'
    },
    BatStatus: {
      voltage: 0,
      remaining: 0,
      amper: 0
    },
    currentWP: {
      lastWp: 0
    },
    distToWp: {
      distToWp: 0
    },
    readWPList: {},
    receivedArrayTel: [],
    waypointsOnRPA: 0,
    totalWPdownloadedDOWN: 0,
    downloadingWP: false,
    downloadedWPs: false,
    uploadingWP: false,
    uploadedWPs: false,
    totalWPdownloadedUP: 0,
    totalWPinAutoPilotUP: 0,
    waypointSent: 0,
    waypointRead: 0,
    waypointsToSend: 0,
    pitotCal: false,
    logList: [],
    isLogLoading: false,
    isLogConverted: false
  };

  componentDidMount() {
    const { isPreFlight, getPath, match } = this.props;
    if (isPreFlight) {
      getPath(match.path.split('/').pop());
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { isPreFlight, getPath, match, isCableConn } = this.props;
    const { telemetryConnection } = this.state;
    if (isPreFlight) {
      if (match.path.split('/').pop() !== prevProps.match.path.split('/').pop()) {
        getPath(match.path.split('/').pop());
      }
    }

    const listenerProps = [
      'downloadWP',
      'sendWP',
      'gps',
      'attitude',
      'speed',
      'flightMode',
      'nextWPInfo',
      'battery',
      'calibration',
      'logs',
      'isCableConn'
    ];

    const oldListenerProps = Object.keys(this.props)
      .filter(key => listenerProps.includes(key))
      .reduce((obj, key) => ({ ...obj, [key]: this.props[key] }), {});

    const newListenerProps = Object.keys(prevProps)
      .filter(key => listenerProps.includes(key))
      .reduce((obj, key) => ({ ...obj, [key]: prevProps[key] }), {});

    const listenerPropsChanged = !isEqual(oldListenerProps, newListenerProps);

    const isTelemetryClientDefined = !isNil(this.telemetryClient);
    const noTelemetryURL = telemetryConnection === '';
    const telemetryChanged = prevState.telemetryConnection !== telemetryConnection;
    if (!noTelemetryURL) {
      if (telemetryChanged) {
        this.closeConnection();
        if (isTelemetryClientDefined) {
          this.initializeTelemetry();
        }
      }
      if (!isTelemetryClientDefined) {
        this.initializeTelemetry();
        if (isCableConn) {
          setTimeout(this.connectToSerial, 500);
        }
      } else if (isTelemetryClientDefined && listenerPropsChanged) {
        this.loadListeners();
      }
    }
  }

  componentWillUnmount() {
    if (this.inter) {
      clearInterval(this.inter);
    }
    this.closeConnection();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    // Store prevUserId in state so we can compare when props change.
    // Clear out any previously-loaded user data (so we don't render stale stuff).
    const isTelemetryURLUndefined = isNil(nextProps.telemetryConnection.url);
    const isTelemetryURLSame = nextProps.telemetryConnection.url === prevState.telemetryConnection;
    const telemetryChangedState = {
      telemetryConnection: nextProps.telemetryConnection.url,
      connectionWebsocket: false,
      connectionSerial: false,
      receivingData: false
    };
    if (!isTelemetryURLUndefined && !isTelemetryURLSame) {
      return telemetryChangedState;
    }
    return null;
  }

  connectToSerial = () => {
    const { connectionSerial, toPort, bauds } = this.state;
    const { isCableConn } = this.props;
    if (!connectionSerial) {
      if (isCableConn) {
        this.telemetryClient.connectToSerial(toPort, 115200);
      } else {
        this.telemetryClient.connectToSerial(toPort, bauds);
      }
    } else {
      this.telemetryClient.closeSerial();
    }
  };

  changeBauds = newBauds => {
    this.setState(newBauds);
  };

  handlePortChange = newPort => {
    this.setState({ toPort: newPort });
  };

  sendRPAToCoordinates = coordinates => {
    this.telemetryClient.sendDroneToCoors(coordinates);
  };

  sendDroneToWaypoint = waypointNumber => {
    this.telemetryClient.sendDroneToWp(waypointNumber);
  };

  readWPTelArray = () => {
    const { connectionSerial } = this.state;
    if (!connectionSerial) {
      Bert.alert('No RPA Connection', 'danger');
      return;
    }
    this.setState({
      receivedArrayTel: [],
      waypointsOnRPA: 0,
      readWPList: {},
      downloadingWP: true,
      downloadedWPs: false,
      waypointRead: 0,
      totalWPdownloadedDOWN: 0
    });
    this.telemetryClient.askForWpList();
  };

  cleanLogList = () => {
    const { logList } = this.state;
    const cleanLogArray = cloneDeep(logList);
    forEach(cleanLogArray, logItem => {
      delete logItem.ready; //eslint-disable-line
      delete logItem.loading; //eslint-disable-line
      delete logItem.transferPercentage; //eslint-disable-line
    });
    this.setState({
      logList: cleanLogArray
    });
  };

  requestLog = logId => {
    const { mission } = this.props;
    const { connectionSerial } = this.state;
    if (!connectionSerial) {
      Bert.alert('No RPA Connection', 'danger');
      return;
    }
    this.cleanLogList();
    // We delay this to give some time to the setState
    delay(async () => {
      try {
        const missionLogPath = await methodPromise('utility.getMissionsLogDir', mission._id);
        const { logList } = this.state;
        const updatedLogArray = cloneDeep(logList);
        const logItem = find(updatedLogArray, log => log.id === logId);
        logItem.loading = true;
        logItem.transferPercentage = 0;
        this.setState({
          logList: updatedLogArray,
          isLogConverted: false
        });
        this.setState({ isLogLoading: true });
        this.telemetryClient.requestLog(logId, missionLogPath);
        Bert.alert('Log Requested', 'success');
      } catch (error) {
        handleErrorInClient(error);
      }
    }, 300);
  };

  requestLogList = () => {
    const { connectionSerial } = this.state;
    if (!connectionSerial) {
      Bert.alert('No RPA Connection', 'danger');
      return;
    }
    this.setState({ logList: [] });
    this.telemetryClient.requestLogList();
  };

  deleteAllLogsInRPA = () => {
    const { connectionSerial } = this.state;
    if (!connectionSerial) {
      Bert.alert('No RPA Connection', 'danger');
      return;
    }
    this.telemetryClient.deleteAllLogs();
    this.setState({ logList: [] });
  };

  calCompass = () => {
    const { rpa } = this.props;
    this.telemetryClient.calCompass();
    try {
      methodPromise('rpas.addCompassCalDate', rpaOps.getId(rpa));
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  calAccelAndSaveDate = () => {
    this.telemetryClient.calIMU();
  };

  nextIMUStep = () => {
    this.telemetryClient.nextIMU();
  };

  killPython = () => {
    this.telemetryClient.killAnyPythonProcess();
  };

  sendWPList2RPA = () => {
    const { mission } = this.props;
    const { connectionSerial } = this.state;
    const waypointList = missionOps.getWaypointList(mission);
    const shootDistance = missionOps.getShootDistance(mission);
    if (isEmpty(waypointList)) {
      Bert.alert('You need to draw the mission', 'danger');
      return;
    }
    if (!connectionSerial) {
      Bert.alert('No RPA Connection', 'danger');
      return;
    }
    if (getTakeOffElevation(waypointList) === -999) {
      Bert.alert('Take Off Point Altitude is set to -999', 'danger');
      return;
    }
    if (isNil(shootDistance)) {
      Bert.alert('Shoot Distance not defined', 'danger');
      return;
    }
    setWaypointTelemetryArray(mission._id);
    setFinalWaypointList(mission._id);
    const waypointTelArray = convertWaypointFeatureCollection2TelemetryArray(
      waypointList,
      shootDistance,
      missionOps.getWaypointReferenceAltitude(mission)
    );
    this.setState({
      waypointsToSend: waypointTelArray.length,
      uploadingWP: true,
      uploadedWPs: false,
      waypointSent: 0,
      totalWPdownloadedUP: 0
    });
    this.telemetryClient.sendWaypointList(waypointTelArray);
    Bert.alert('Waypoint Telemetry Sent', 'success');
    setWaypointTelemetryArray(mission._id, waypointTelArray);
    setFinalWaypointList(mission._id, waypointList);
  };

  toggleArmed = () => {
    const { connectionSerial, HeartBeat } = this.state;
    if (!connectionSerial) {
      Bert.alert('There is no connection to the RPA', 'danger');
      return;
    }
    if (HeartBeat.mode === 'disarmed') {
      this.telemetryClient.arm();
    } else {
      this.telemetryClient.disArm();
    }
  };

  calPitot = () => {
    this.setState({ pitotCal: false });
    this.telemetryClient.calPitot();
  };

  callCameraTrigger = () => {
    const { connectionSerial } = this.state;
    if (!connectionSerial) {
      Bert.alert('There is no connection to the RPA', 'danger');
      return;
    }
    this.telemetryClient.cameraTrigger();
    Bert.alert('Camera Triggered', 'info');
  };

  callResetMissionProgress = () => {
    const { connectionSerial } = this.state;
    if (!connectionSerial) {
      Bert.alert('There is no connection to the RPA', 'danger');
      return;
    }
    this.telemetryClient.sendDroneToWp(0);
    Bert.alert('Mission Progress Reset', 'info');
  };

  toggleFlightMode = newFlightMode => {
    const { connectionSerial } = this.state;
    if (!connectionSerial) {
      Bert.alert('There is no connection to the RPA', 'danger');
      return;
    }
    this.telemetryClient.setFlightMode(newFlightMode);
  };

  initializeTelemetry() {
    const { telemetryConnection } = this.state;
    this.telemetryClient = new WebSocketTelemetry(telemetryConnection);
    this.loadListeners();
  }

  loadListeners() {
    this.telemetryClient.removeAllListeners();
    this.listenToConnStatus();
    this.listenToPorts();
    this.listenToCurrentWP();
    this.listenToBattery();
    this.listenToFlightMode();
    this.listenToSpeed();
    this.listenToAttitude();
    this.listenToGPS();
    this.listenToUploadWP();
    this.listenToDownloadWP();
    this.listenToLogFiles();
    this.listenToCalibration();
    this.checkLastMessageTime();
  }

  closeConnection() {
    const { isCableConn } = this.props;
    if (!isNil(this.telemetryClient)) {
      if (isCableConn) {
        this.telemetryClient.closeSerial();
      }
      this.telemetryClient.removeAllListeners();
      this.telemetryClient.closeWebService();
    }
  }

  checkLastMessageTime() {
    const inter = setInterval(() => {
      const { connectionSerial, lastMessageTimeStamp } = this.state;
      if (connectionSerial) {
        if (lastMessageTimeStamp === '') {
          this.setState({ receivingData: false });
        } else {
          const timeSinceLastMessage = new Date() - lastMessageTimeStamp;
          if (timeSinceLastMessage < 5000) {
            this.setState({ receivingData: true });
          } else {
            this.setState({ receivingData: false });
          }
        }
      } else {
        this.setState({ receivingData: false });
      }
    }, 2000);
    this.inter = inter;
  }

  listenToConnStatus() {
    this.telemetryClient.on('WebSocketConn', value => {
      console.info(`WebSocketConn ${value}`); // eslint-disable-line
      this.setState({
        connectionWebsocket: value,
        lastMessageTimeStamp: new Date(),
        receivingData: false
      });
      if (!value) {
        Bert.alert('Error in Telemetry Server Connection', 'danger');
      }
    });
    this.telemetryClient.on('SerialConn', value => {
      console.info(`SerialConn ${value}`); // eslint-disable-line
      this.setState({
        connectionSerial: value,
        lastMessageTimeStamp: new Date(),
        receivingData: value
      });
    });
  }

  listenToPorts() {
    this.telemetryClient.on('ports', msg => {
      this.setState({
        lastMessageTimeStamp: new Date(),
        ports: msg.ports.ports
      });
      if (msg.ports.ports.length > 0) {
        this.setState({ toPort: msg.ports.ports[0].portName });
      }
    });
  }

  listenToCurrentWP() {
    const { nextWPInfo } = this.props;
    if (nextWPInfo) {
      this.telemetryClient.on('currentWP', wpData => {
        this.setState({
          currentWP: wpData,
          lastMessageTimeStamp: new Date()
        });
      });
      this.telemetryClient.on('distToWp', wpData => {
        this.setState({
          distToWp: wpData,
          lastMessageTimeStamp: new Date()
        });
      });
    }
  }

  listenToBattery() {
    const { battery } = this.props;
    if (battery) {
      this.telemetryClient.on('BatStatus', batStatus => {
        this.setState({
          BatStatus: batStatus,
          lastMessageTimeStamp: new Date()
        });
      });
    }
  }

  listenToFlightMode() {
    const { flightMode } = this.props;
    if (flightMode) {
      this.telemetryClient.on('HeartBeat', hearbeatData => {
        this.setState({
          HeartBeat: hearbeatData,
          lastMessageTimeStamp: new Date()
        });
      });
    }
  }

  listenToSpeed() {
    const { speed } = this.props;
    if (speed) {
      this.telemetryClient.on('VFRData', vfrData => {
        this.setState({
          VFRData: vfrData,
          lastMessageTimeStamp: new Date()
        });
      });
    }
  }

  listenToAttitude() {
    const { attitude } = this.props;
    if (attitude) {
      this.telemetryClient.on('attitudeData', attData => {
        this.setState({
          attitudeData: attData,
          lastMessageTimeStamp: new Date()
        });
      });
    }
  }

  listenToGPS() {
    const { gps } = this.props;
    if (gps) {
      this.telemetryClient.on('GPSData', gpsData => {
        this.setState({
          GPSData: gpsData,
          lastMessageTimeStamp: new Date()
        });
      });
    }
  }

  listenToUploadWP() {
    const { sendWP } = this.props;
    if (sendWP) {
      this.telemetryClient.on('uploadedOneWp', value => {
        this.setState({
          waypointSent: value.data.seq + 1,
          lastMessageTimeStamp: new Date(),
          uploadingWP: true,
          uploadedWPs: false
        });
      });
      this.telemetryClient.on('uploadedAllWps', value => {
        this.setState({
          uploadedWPs: value.data.finished,
          lastMessageTimeStamp: new Date(),
          totalWPdownloadedUP: value.data.totalDownloaded,
          totalWPinAutoPilotUP: value.data.totalInAutopilot,
          uploadingWP: false
        });
        if (value.data.finished) {
          Bert.alert('Waypoints uploaded correctly', 'success');
        } else {
          const { mission } = this.props;
          setWaypointTelemetryArray(mission._id);
          setFinalWaypointList(mission._id);
          Bert.alert('Error in waypoint upload', 'danger');
        }
      });
    }
  }

  listenToDownloadWP() {
    const { downloadWP } = this.props;
    if (downloadWP) {
      this.telemetryClient.on('missionWpCount', value => {
        this.setState({
          waypointsOnRPA: value,
          lastMessageTimeStamp: new Date(),
          downloadingWP: true,
          downloadedWPs: false
        });
      });

      this.telemetryClient.on('downloadedOneWp', value => {
        const { receivedArrayTel, waypointsOnRPA } = this.state;
        if (receivedArrayTel.length < waypointsOnRPA) {
          this.setState(prevState => ({
            receivedArrayTel: [...prevState.receivedArrayTel, value.data],
            waypointRead: value.data.seq + 1,
            lastMessageTimeStamp: new Date(),
            downloadingWP: true,
            downloadedWPs: false
          }));
        }
        // if download is finished compute the array and update state
        if (value.data.seq + 1 === waypointsOnRPA) {
          this.receivedArrayTel();
          this.setState({
            downloadedWPs: true,
            totalWPdownloadedDOWN: value.data.seq + 1,
            downloadingWP: false,
            lastMessageTimeStamp: new Date()
          });
          Bert.alert('Waypoints Read', 'success');
        }
      });

      this.telemetryClient.on('downloadedAllWp', value => {
        // FIXME this does not work yet
        console.info(JSON.stringify(value)); // eslint-disable-line
        //   this.setState({
        //     downloadedWPs: true,
        //     totalWPdownloadedDOWN: Number(value.data.totalDownloaded),
        //     downloadingWP: false,
        //     lastMessageTimeStamp: new Date()
        //   });
        //   if (this.state.receivedArrayTel.length === this.state.waypointsOnRPA) {
        //     this.receivedArrayTel();
        //     Bert.alert('Waypoints Read', 'success');
        //   } else {
        //     Bert.alert('Error in waypoint download', 'danger');
        //   }
      });
    }
  }

  listenToCalibration() {
    const { calibration } = this.props;
    if (calibration) {
      this.telemetryClient.on('pitot', value => {
        this.setState({
          pitotCal: value.data.finished,
          lastMessageTimeStamp: new Date()
        });
      });
      this.telemetryClient.on('imu', value => {
        console.info(`Accelerometers Calibration Message - ${value.data.msg}`); // eslint-disable-line
        const calMessage = value.data.msg;
        const successMessage = 'Calibration successful                            ';
        if (calMessage === successMessage) {
          this.setState({
            imuCal: true,
            imuMessage: calMessage,
            lastMessageTimeStamp: new Date()
          });
          const { rpa } = this.props;
          try {
            methodPromise('rpas.addAccelCalDate', rpa._id);
          } catch (error) {
            handleErrorInClient(error);
          }
        } else {
          this.setState({
            imuCal: false,
            imuMessage: calMessage,
            lastMessageTimeStamp: new Date()
          });
        }
      });
    }
  }

  listenToLogFiles() {
    const { logs } = this.props;
    if (logs) {
      this.telemetryClient.on('itemLogList', msg => {
        this.setState(prevState => ({
          logList: [...prevState.logList, msg],
          lastMessageTimeStamp: new Date()
        }));
      });
      this.telemetryClient.on('logData', msg => {
        const { logList } = this.state;
        const updatedLogArray = cloneDeep(logList);
        const logItem = find(updatedLogArray, log => log.id === msg.id);
        const totalSize = logItem.MbSize;
        const transferPercentage = ((msg.ofset / totalSize) * 100).toFixed(0);
        logItem.transferPercentage = transferPercentage;
        this.setState({
          logList: updatedLogArray,
          lastMessageTimeStamp: new Date()
        });
      });

      this.telemetryClient.on('logConverted', async msg => {
        const { isLogConverted, logList } = this.state;
        const { mission } = this.props;
        if (!isLogConverted) {
          console.info('convierto el log'); // eslint-disable-line
          const updatedLogArray = cloneDeep(logList);
          const logItem = find(updatedLogArray, log => log.id === msg.id);
          logItem.ready = true;
          logItem.loading = false;
          logItem.transferPercentage = 100;
          this.setState({
            logList: updatedLogArray,
            lastMessageTimeStamp: new Date()
          });
          try {
            await methodPromise('utility.parseLogFile', mission._id);
            this.setState({ isLogConverted: true, isLogLoading: false });
          } catch (error) {
            handleErrorInClient(error);
          }
        }
      });
    }
  }

  receivedArrayTel() {
    const { receivedArrayTel, waypointsOnRPA } = this.state;
    if (receivedArrayTel.length !== waypointsOnRPA) {
      Bert.alert('Waypoints not downloaded', 'warning');
      this.setState({ receivedArrayTel: [], waypointsOnRPA: 0, readWPList: {} });
    }
    const featureCollectionfromArray = convertWaypointArrayToGeoJSON(receivedArrayTel);
    const featureCollectionfromArrayNumbers = setWaypointNumbers(featureCollectionfromArray);
    this.setState({ readWPList: featureCollectionfromArrayNumbers });
  }

  render() {
    const {
      getPath,
      loading,
      isPreFlight,
      telemetryConnection,
      downloadWP,
      sendWP,
      gps,
      attitude,
      speed,
      flightMode,
      nextWPInfo,
      battery,
      isCableConn,
      component,
      ...propsToPass
    } = this.props;
    const telemetryActions = {
      changeBauds: this.changeBauds,
      handlePortChange: this.handlePortChange,
      connectToSerial: this.connectToSerial,
      readWPTelArray: this.readWPTelArray,
      sendWPList2RPA: this.sendWPList2RPA,
      toggleFlightMode: this.toggleFlightMode,
      callResetMissionProgress: this.callResetMissionProgress,
      callCameraTrigger: this.callCameraTrigger,
      calPitot: this.calPitot,
      toggleArmed: this.toggleArmed,
      sendRPAToCoordinates: this.sendRPAToCoordinates,
      sendDroneToWaypoint: this.sendDroneToWaypoint,
      requestLog: this.requestLog,
      requestLogList: this.requestLogList,
      deleteAllLogsInRPA: this.deleteAllLogsInRPA,
      calCompass: this.calCompass,
      calAccelAndSaveDate: this.calAccelAndSaveDate,
      nextIMUStep: this.nextIMUStep,
      killPython: this.killPython
    };
    if (loading) {
      return <Loading />;
    }
    if (isNil(telemetryConnection)) {
      return (
        <Alert bsStyle="danger">
          <h5>No telemetry Configuration Selected</h5>
        </Alert>
      );
    }
    return component(this.state, propsToPass, telemetryActions);
  }
}

TelemetryContainer.defaultProps = {
  telemetryConnection: {},
  match: {},
  isPreFlight: false,
  getPath: () => {},
  downloadWP: false,
  sendWP: false,
  gps: false,
  attitude: false,
  speed: false,
  flightMode: false,
  nextWPInfo: false,
  battery: false,
  calibration: false,
  logs: false,
  isCableConn: false,
  mission: {},
  rpa: {}
};

TelemetryContainer.propTypes = {
  mission: PropTypes.object,
  rpa: PropTypes.object,
  telemetryConnection: PropTypes.object,
  component: PropTypes.func.isRequired,
  isPreFlight: PropTypes.bool,
  getPath: PropTypes.func,
  match: PropTypes.object,
  downloadWP: PropTypes.bool,
  sendWP: PropTypes.bool,
  loading: PropTypes.bool.isRequired,
  gps: PropTypes.bool,
  battery: PropTypes.bool,
  attitude: PropTypes.bool,
  speed: PropTypes.bool,
  flightMode: PropTypes.bool,
  nextWPInfo: PropTypes.bool,
  calibration: PropTypes.bool,
  logs: PropTypes.bool,
  isCableConn: PropTypes.bool
};

export default withTracker(() => {
  const subscription = Meteor.subscribe('telemetryConnections');
  return {
    loading: !subscription.ready(),
    telemetryConnection: TelemetryConnections.findOne({ selected: true })
  };
})(TelemetryContainer);
